import { Component, Input, OnInit, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { pageLoginService } from "../../../services/page-login/page-login.service";
import { EnvironmentService } from 'src/app/services/environment.service';
import { ScaleConstant } from "../../../constants/global.constant";

@Component({
  selector: 'app-page-login-img',
  templateUrl: './page-login-img.component.html',
  styleUrls: ['./page-login-img.component.scss']
})
export class PageLoginImgComponent implements OnInit {
  @Input()pageLogin : any
  @Input()imageSrc: string;
  @Input()isVisible: boolean;
  @Input() colorCode: string;
  copyrightHtml: string = "";
  dialogInfoHtml: string = "";
  loginInfoHtml: string = "";
   defaultPageLogin: any = {
    title: '',
    content: '',
    description: '',
    pageLoginReseauSocials: []
  };
   @ViewChild('loginContent', { read: ElementRef }) loginContentRef: ElementRef;
   @ViewChild('loginTitle', { read: ElementRef }) loginTitleRef: ElementRef;
  private readonly SCALE_DELAY = ScaleConstant.SCALE_DELAY;
  private readonly INITIAL_SCALE_DELAY = ScaleConstant.INITIAL_SCALE_DELAY;
  private readonly DATA_LOAD_SCALE_DELAY = ScaleConstant.DATA_LOAD_SCALE_DELAY;
  private readonly MIN_TEXT_SCALE = ScaleConstant.MIN_TEXT_SCALE;
  private readonly MIN_IMAGE_SCALE = ScaleConstant.MIN_IMAGE_SCALE;
  private readonly OVERFLOW_THRESHOLD = ScaleConstant.OVERFLOW_THRESHOLD;
  private readonly MILD_OVERFLOW = ScaleConstant.MILD_OVERFLOW;
  private readonly MODERATE_OVERFLOW = ScaleConstant.MODERATE_OVERFLOW;
  private readonly HEAVY_OVERFLOW = ScaleConstant.HEAVY_OVERFLOW;
  constructor(private pageLoginService: pageLoginService, private cdr: ChangeDetectorRef, private environmentService: EnvironmentService) {}

  ngOnInit(): void {
    this.loadDataLoginPage(this.environmentService.get().companySiteIdentifier);  
  }


  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scaleTitleToFit();
      this.scaleContentToFit();
    }, this.INITIAL_SCALE_DELAY);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.scaleTitleToFit();
    this.scaleContentToFit();
  }

    scaleTitleToFit(): void {
    if (!this.loginTitleRef) return;

    const titleElement = this.loginTitleRef.nativeElement;
    const container = titleElement.parentElement;
    if (!container) return;

    titleElement.style.transform = 'none';

    setTimeout(() => {
      const scaleWidth = (container.clientWidth - 16) / titleElement.scrollWidth;
      const scaleHeight = container.clientHeight / titleElement.scrollHeight;
      const scale = Math.min(scaleWidth, scaleHeight, 1);

      if (scale < 1) {
        titleElement.style.transform = `scale(${scale})`;
        titleElement.style.transformOrigin = 'center';
      }
    }, this.SCALE_DELAY);
  }

  scaleContentToFit(): void {
    if (!this.loginContentRef) return;

    const contentElement = this.loginContentRef.nativeElement;
    const container = contentElement.parentElement;
    if (!container) return;

    // Reset scaling
    contentElement.style.fontSize = '';
    const images = contentElement.querySelectorAll('img');
    images.forEach((img: HTMLElement) => {
      img.style.transform = 'none';
      img.style.maxWidth = '100%';
    });

    setTimeout(() => {
      contentElement.style.width = '100%';
      const containerHeight = container.clientHeight;
      const contentHeight = contentElement.scrollHeight;
      
      // Calculate overflow ratio (how much content exceeds container)
      const overflowRatio = contentHeight / containerHeight;
      
      // Only apply scaling if content exceeds 100% of container height
      if (overflowRatio > this.OVERFLOW_THRESHOLD) {
        // Determine scaling intensity based on overflow amount
        let imageFactor: number;
        let textFactor: number;
        
        if (overflowRatio <= this.MILD_OVERFLOW) {
          // Mild overflow (100%-150%): gentle scaling
          imageFactor = 0.90;
          textFactor = 0.95;
        } else if (overflowRatio <= this.MODERATE_OVERFLOW) {
          // Moderate overflow (150%-250%): moderate scaling
          imageFactor = 0.80;
          textFactor = 0.90;
        } else if (overflowRatio <= this.HEAVY_OVERFLOW) {
          // Heavy overflow (250%-400%): stronger scaling
          imageFactor = 0.70;
          textFactor = 0.85;
        } else {
          // Extreme overflow (>400%): aggressive scaling
          imageFactor = 0.60;
          textFactor = 0.80;
        }
        
        // Calculate actual scale needed
        const scaleNeeded = containerHeight / contentHeight;
        
        // Scale images
        images.forEach((img: HTMLElement) => {
          const imgScale = Math.max(scaleNeeded * imageFactor, this.MIN_IMAGE_SCALE);
          
          // Get parent's text-align to position image accordingly
          const parent = img.parentElement;
          const textAlign = parent ? getComputedStyle(parent).textAlign : 'left';
          
          // Set transform origin based on text alignment
          let transformOrigin = 'center top';
          let marginLeft = 'auto';
          let marginRight = 'auto';
          
          if (textAlign === 'left' || textAlign === 'start') {
            transformOrigin = 'left top';
            marginLeft = '0';
            marginRight = 'auto';
          } else if (textAlign === 'right' || textAlign === 'end') {
            transformOrigin = 'right top';
            marginLeft = 'auto';
            marginRight = '0';
          }
          
          img.style.transform = `scale(${imgScale})`;
          img.style.transformOrigin = transformOrigin;
          img.style.marginLeft = marginLeft;
          img.style.marginRight = marginRight;
          img.style.marginBottom = `${-img.scrollHeight * (1 - imgScale)}px`;
        });
        
        // Scale text
        const textScale = Math.max(scaleNeeded * textFactor, this.MIN_TEXT_SCALE);
        contentElement.style.fontSize = `${textScale}em`;
      } else {
        // Content fits within 100% - no scaling needed
        contentElement.style.fontSize = '1em';
      }
    }, this.SCALE_DELAY);
  }

  getPrimaryColor(): string {
    this.colorCode = getComputedStyle(document.documentElement)
      .getPropertyValue('--primary-color').trim();
    return this.colorCode;
  }

  loadDataLoginPage(COMPANY_SITE_IDENTIFIER): void {
    this.pageLoginService.getPageLogin(COMPANY_SITE_IDENTIFIER).subscribe(
      (data: any) => {
        this.pageLogin = data;
        this.pageLogin.content = data.content || '';
        
        if (data.file) {
          this.imageSrc = "data:image/png;base64," + data.file;
        } else {
          this.colorCode = data.colorCode || this.getPrimaryColor();
        }

        this.cdr.detectChanges();
        setTimeout(() => {
          this.scaleTitleToFit();
          this.scaleContentToFit();
        }, this.DATA_LOAD_SCALE_DELAY);
      },
      (error: any) => {
        this.pageLogin = this.defaultPageLogin;
        console.error('getPageLogin Error', error);
      }
    );
  }
}

